import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const routeBackofficeSftpConsult = [
  {
    route: 'ListSftp',
    text: 'Liste des fichiers SFTP',
    href: '/backoffice/sftp/consult',
    home: true,
    menuHeader: true,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
}))

const getExternalOfficeSftpConsult: any[] = [...routeBackofficeSftpConsult].map(route => ({
  ...route,
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_CONSULT_USER_SFTP],
}))

export default getExternalOfficeSftpConsult
